var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card__content blogpost__description shadow px-2 text-uppercase",class:_vm.wrapperClass,style:({ 'text-align': _vm.textAlign })},[_c('p',{class:_vm.headingClass,domProps:{"innerHTML":_vm._s(_vm.heading)}})])}
var staticRenderFns = []

export { render, staticRenderFns }